import type { Logger } from '@seek/logger';
import { createContext, useContext } from 'react';

const ServerLogContext = createContext<Logger | undefined>(undefined);

interface ServerLogContextProviderProps {
  serverLogger?: Logger;
  children: React.ReactNode;
}

export const ServerLogProvider = ({
  serverLogger,
  children,
}: ServerLogContextProviderProps) => (
  <ServerLogContext.Provider value={serverLogger}>
    {children}
  </ServerLogContext.Provider>
);

// Note: serverLogger is always undefined on the client side,
export const useServerLogger = () => {
  const context = useContext(ServerLogContext);
  return context;
};
